import {useState} from "react";
import {PAGE_LENGTH} from '@/utils/constants/constants';

/** Normalize search so clear ("") matches the initial null cache key. */
export function normalizeSearchItem(searchText: string | null | undefined): string | null {
    if (searchText == null) return null;
    const trimmed = String(searchText).trim();
    return trimmed === "" ? null : trimmed;
}

export const useDataQueries = () => {
    const [pageNo, setPageNo] = useState<any>(1);
    const [dataLength, setDataLength] = useState<any>(PAGE_LENGTH);
    const [sorting, setSorting] = useState<any>({created_at: -1})
    const [filter, setFilter] = useState<any>({});
    const [searchItem, setSearchItemState] = useState<any>(null)

    const setSearchItem = (value: string | null | undefined) => {
        setSearchItemState(normalizeSearchItem(value));
    };

    const resetDataQueries = () => {
        setPageNo(1)
        setDataLength(PAGE_LENGTH)
        setSorting({created_at: -1})
        setSearchItemState(null)
        setFilter({})
    }

    return [ pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem,resetDataQueries ]
}